export const SETTINGS = {
    toggleSidebar: 'SETTINGS_TOGGLE_SIDEBAR'
}

export const toggleSidebar = (text) => {
    return {
        type: SETTINGS.toggleSidebar
    }
}